import { styled } from '@lichtblick/styled';

export const Container = styled.div`
  display: flex;
  align-items: center;

  input {
    height: 2.5rem;
    border-right: none;
    border-top-right-radius: 0;
    border-bottom-right-radius: 0;
  }

  button {
    border-left: none;
    border-top-left-radius: 0;
    border-bottom-left-radius: 0;

    &:focus-visible {
      border-top-left-radius: 0;
      border-bottom-left-radius: 0;
    }
  }
`;
